<template>
	<div class="service" style="background-color: #f7f7f7;">
		<div class="item">
			<img src="@/assets/images/footericon1.svg" alt="">
			<p>品质保证</p>
		</div>
		<div class="item">
			<img src="@/assets/images/footericon2.svg" alt="">
			<p>无房退款</p>
		</div>
		<div class="item">
			<img src="@/assets/images/footericon3.svg" alt="">
			<p>个性定制</p>
		</div>
		<div class="item">
			<img src="@/assets/images/footericon4.svg" alt="">
			<p>无障碍服务</p>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Service',
	components: {

	},
	computed: {

	},
	data() {
		return {

		}
	},
	mounted() {

	},
	methods: {

	}

}
</script>

<style lang="scss" scoped></style>
